﻿import { mapGetters, mapState } from 'vuex';

export default {
    name: 'addresslookup',
    template: '#addresslookup-template',
    data: () => ({
        caretPosition: 0,
        focusIndex: 0,
        addressFocused: false,
        queryFocus: true,
        query: '',
        address: {},
        showTopBar: true
    }),
    computed: 
        Object.assign(
            mapState({
                suggestions: state => state.offeringpage.addresslookup.suggestions,
                hasLookupFailure: state => state.offeringpage.addresslookup.failure
            }),
            {
                buttonActive(){
                    return this.query.length >= 3;
                }
            }

        ),
    props: ['blockid', 'minchars'],
    methods: {
        changeAddressFocus(hasFocus) {
            this.addressFocused = hasFocus;
            this.toggleTopBar();
        },
        getSuggestions(e) {
            this.caretPosition = e.target.selectionStart;

            if (this.query.length >= this.minchars && this.addressFocused) {
                this.$store.dispatch('getAddressSuggestions', { query: this.query, caretPosition: this.caretPosition });
            } else {
                this.$store.dispatch('resetAddressSuggestions');
            }
        },
        getProducts() {
            if (!this.address || !this.address.postCode) {
                if (this.suggestions[this.focusIndex].streetNumber) {
                    this.$store.dispatch('pickAddressSuggestion', this.suggestions[this.focusIndex]);
                    this.$store.dispatch('lookupProducts', this.blockid);
                }else {
                    this.$store.dispatch('invalidAddressPicked', this.query);
                }
            }else{
                this.$store.dispatch('pickAddressSuggestion', this.address);
                this.$store.dispatch('lookupProducts', this.blockid);
            }

            var element = document.getElementById("product-bookmark");
            element.scrollIntoView({ behavior: "smooth", block: "start", inline: "center"});
        },
        setFocus(e) {
            var keycode = e.keyCode;
            var listLn = this.suggestions.length;

            switch (keycode) {
                // Key: Down
                case 40:
                    if (listLn - 1 > this.focusIndex) {
                        this.focusIndex += 1;
                    }
                    this.scroll();
                    break;
                // Key: Up
                case 38:
                    if (this.focusIndex > 0) {
                        this.focusIndex -= 1;
                    }
                    this.scroll();
                    break;
                // Key: Tab or Enter
                case 9:
                case 13:
                    if (listLn < 1) {
                        this.getProducts();
                        break;
                    }
                    this.selectAddress(this.focusIndex);
                    this.focusIndex = 0;
                    e.target.blur();
                    break;
                // Key: Esc
                case 27:
                    this.$store.dispatch('resetSelectedAddress');
                    break;
                default: 
                    this.focusIndex = 0;
            }
        },
        scroll(){
            var currentElement = document.getElementById("address-suggesion-" + this.focusIndex);
            currentElement.parentNode.scrollTop = currentElement.offsetTop - 12; //12 to fit padding
        },
        checkSelected(index) {
            return {
                'selected' : index === this.focusIndex
            };
        },
        clickAddressSuggestion(index) {
            this.selectAddress(index);
        },
        selectAddress(index) {
            const address = this.suggestions[index];
            if (!address) {
                return false;
            }

            if (address.type === 'vejnavn') {
                this.address = {};
                this.query = address.friendly + ' ';

                this.$store.dispatch('resetAddressSuggestions');
                setTimeout(() => this.$refs.addressQuery.focus(), 10);
                this.$store.dispatch('getAddressSuggestions', { query: address.friendly, hasStreetName: true });
            }
            else if (address.type === 'adgangsadresse') {
                this.address = {};
                this.query = address.friendly;

                setTimeout(() => this.$refs.addressQuery.focus(), 10);
                this.$store.dispatch('getAddressSuggestions', {query: this.query, hasStreetName: true, addressId: address.id});
            }
            else if (address.type === 'adresse') {
                this.address = address;
                this.query = address.friendly;
                this.$store.dispatch('resetAddressSuggestions');
            }
        },
        toggleTopBar() {
            var x = document.getElementsByClassName("nav-main-wrapper");
            if (this.showTopBar && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                for (var i = 0; i < x.length; i++) {
                    x[i].style.display = "none";
                    this.showTopBar = false;
                }
            } else {
                for (var i = 0; i < x.length; i++) {
                    x[i].style.display = "block";
                    this.showTopBar = true;
                }
            }
        }
    }
}
